<template>
    <div :class="classes" @scroll="event => event.stopPropagation()">
        <div :style="isOpen? 'width: ' + width + ';' + 'height: ' + height : 'width: 0%; height: ' + height">
            <div class="overlay-header bg-white w-100 shadow-sm px-2">
                <div class="mr-md-5" :style="isMobile? 'width: 100%;' : ''">
                    <slot name="header"></slot>
                </div>
                <a v-if="!hideClose" href="javascript:void(0)" :class="parseInt(width) > 90 ? 'closebtn ext' : 'closebtn'" @click="close">&times;</a>
            </div>
            <div class="overlay-content">
                <slot></slot>
            </div>
            <div v-if="isOpen" class="overlay-footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import MobileDetector from '../common/MobileDetector'

export default {
  name: 'OverlayModal',
  mixins: [MobileDetector],
  data: function () {
    return {
      isOpen: false
    }
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    hideClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return this.isOpen ? 'overlay-modal open' : 'overlay-modal'
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    close () {
      this.$emit('close')
      this.isOpen = false
    }
  }
}
</script>
<style lang="scss">

  .overlay-modal > div > div.overlay-header > a.ext.closebtn {
      background: $secondary !important;
      color: $white !important;
      padding: 0.1rem 0.4rem 0.2rem 0.4rem;
      right: 10px;
      }
@media(min-width: 768px) {
  .overlay-modal > div > div.overlay-header > a.ext.closebtn {
      position: absolute;
      margin: 0;
      border-radius: 50px;
      border: 1px solid transparent;
      opacity: .9;
      padding-left: 10px;
      &::after {
        content: "CHIUDI";
        font-size: 0.85rem;
        margin: 0px 10px;
        height: 1px;
        position: relative;
        top: -4px;
        font-weight: bold;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/front/components/modals/OverlayModal.vue